import { createColumnHelper } from '@tanstack/react-table';

import { ContainerGroup } from '@/react/azure/types';

export const columnHelper = createColumnHelper<ContainerGroup>();
